import { classNames } from '@framework/utils';

type Props = {
  children: React.ReactNode;
};

export const PageSection: React.FC<Props> = ({ children }: Props) => {
  return <div className={classNames('pb-32')}>{children}</div>;
};
